import { render, staticRenderFns } from "./EditDelivery.vue?vue&type=template&id=c1f60356&scoped=true&"
import script from "./EditDelivery.vue?vue&type=script&lang=js&"
export * from "./EditDelivery.vue?vue&type=script&lang=js&"
import style0 from "./EditDelivery.vue?vue&type=style&index=0&id=c1f60356&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1f60356",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\KoushalManna\\Projects\\NPCC\\NPCC_UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1f60356')) {
      api.createRecord('c1f60356', component.options)
    } else {
      api.reload('c1f60356', component.options)
    }
    module.hot.accept("./EditDelivery.vue?vue&type=template&id=c1f60356&scoped=true&", function () {
      api.rerender('c1f60356', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/delivery/DeliveryManagement/EditDelivery.vue"
export default component.exports